var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-o2o-multi-evaluate-dialog" },
    [
      _c(
        "yxtf-dialog",
        {
          attrs: {
            visible: _vm.showDialog,
            "close-on-click-modal": false,
            "show-close": false,
            width: "520px",
            "append-to-body": "",
            "modal-append-to-body": "",
            cutline: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-o2o-multi-evaluate-dialog__content" },
            [
              _c("yxtf-svg", {
                attrs: {
                  width: "88px",
                  height: "88px",
                  "icon-class": "biz/result-success-icon",
                },
              }),
              _c(
                "div",
                {
                  staticClass:
                    "standard-size-20 yxt-weight-5 mt16 color-gray-10",
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_o2o_submitsuccesss" /**提交成功 */))
                  ),
                ]
              ),
              _vm.countDownFlag
                ? _c("div", { staticClass: "color-gray-8 mt12" }, [
                    _vm._v(_vm._s(_vm.message)),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mt32" },
                [
                  _vm.hasNext
                    ? [
                        _c(
                          "yxtf-button",
                          {
                            attrs: { type: _vm.mergeFlag ? "" : "primary" },
                            on: { click: _vm.toDetail },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_o2o_viewresult" /**pc_biz_o2o_viewresult */
                                )
                              )
                            ),
                          ]
                        ),
                        _vm.mergeFlag
                          ? _c(
                              "yxtf-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.toNext },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_o2o_nextimmediate" /**立即跳转下一个 */
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _c(
                        "yxtf-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toDetail },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_biz_o2o_viewresult" /**pc_biz_o2o_viewresult */
                              )
                            )
                          ),
                        ]
                      ),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }